import { render, staticRenderFns } from "./operatingWorkbench.vue?vue&type=template&id=f447434e&"
import script from "./operatingWorkbench.vue?vue&type=script&lang=js&"
export * from "./operatingWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./operatingWorkbench.vue?vue&type=style&index=0&id=f447434e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports